import {combineReducers} from 'redux';
import {tabletErrorsByBundle} from './tablet-errors-by-bundle';

export default combineReducers({
    tabletErrorsByBundle,
});
